module.exports = __webpack_public_path__ + "img/Transportation.ab458917.svg";